import React, { useEffect, useState } from 'react';
import './App.css';
import { FormControl, Input} from '@material-ui/core';
import Message from './Message';
import db from './firebase';
//import Icon from '@material-ui/core/Icon';
import firebase from 'firebase';
import FlipMove from 'react-flip-move';
import SendIcon from '@material-ui/icons/Send';
import { IconButton } from '@material-ui/core';

function App() {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [username, setUsername] = useState('');

  // console.log(messages);
  // console.log(input);

  useEffect(() => {
    db.collection('messages')
    .orderBy('timestamp', 'desc')
    .onSnapshot(snapshot => {
      setMessages(snapshot.docs.map(doc => ({id: doc.id, message: doc.data()})))
    })
  },[])

  useEffect(() => {
    setUsername(prompt("Please Enter Your Name:"));
  }, [])

  const sendMessage = (event) =>{
    event.preventDefault();

    db.collection('messages').add({
      message: input,
      username: username,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    })
    // setMessages([...messages, {username: username, text: input}]);
    setInput('');
  
  }
  return (
    <div className="App">
      <img src="https://facebookbrand.com/wp-content/uploads/2020/10/Logo_Messenger_NewBlurple-399x399-1.png?w=75&h=75" alt="logo"/>
      <h3>Welcome {username}</h3>

      <form className="app__form">
        <FormControl className="app__formControl">
          {/*<InputLabel>Enter a message</InputLabel>*/}
          <Input className="app__input" placeholder="Enter a message..." value={input} onChange={event => setInput(event.target.value)}/>
          
          <IconButton className="app__iconButton" disabled={!input}
            variant="contained" color="primary"
            type="submit" 
            onClick={sendMessage}>
            <SendIcon />
          </IconButton>
          
            {/*<Button disabled={!input}
              variant="contained" color="primary"
              type="submit" 
              onClick={sendMessage}>
              Send Message
            </Button>*/}
        </FormControl>
      </form>
      {/* messages themselves */}
        <FlipMove>
        {
          messages.map(({id, message}) => (
            <Message key={id} message={message} username={username}/>
          ))
        }
        </FlipMove>
      
    </div>
  );
}

export default App;
